import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { margin, width } from 'styled-system';

import Skeleton from '../Base';

const StyledButtonSkeleton = styled(Skeleton)`
  height: 49px;
  ${width}
  ${margin}

  ${(props) =>
    ({
      sm: css`
        height: 41px;
      `,
    })[props.size]}
`;

const ButtonSkeleton = (props) => (
  <StyledButtonSkeleton width="15rem" {...props} />
);

ButtonSkeleton.propTypes = StyledButtonSkeleton.propTypes;

export default ButtonSkeleton;
